import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Collapsible from 'react-collapsible';

// A Collapsible whose open state is mirrored in the URL hash, so a section can be linked to directly.
function AnchorCollapsible({ id, title, children, ...rest }) {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const isTarget = hash === `#${id}`;
  const [open, setOpen] = useState(isTarget);

  useEffect(() => {
    if (isTarget) {
      setOpen(true);
    }
  }, [isTarget]);

  const handleTriggerClick = () => {
    if (open) {
      setOpen(false);
      if (isTarget) {
        navigate({ hash: '' }, { replace: true });
      }
    } else {
      setOpen(true);
      navigate({ hash: `#${id}` }, { replace: true });
    }
  };

  return (
    <Collapsible
      {...rest}
      open={open}
      handleTriggerClick={handleTriggerClick}
      trigger={<h3 id={id}>{title}</h3>}
    >
      {children}
    </Collapsible>
  );
}

export default AnchorCollapsible;
